<div *ngIf="isLoading" class="loader-container">
    <div class="loader"></div>
    <p>{{ loadingMessage }}</p>
</div>